import React from 'react';

import { Modal, Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../../symphony';

import { SlDiscussContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../../global-interface';

import s from './DeleteReplyModal.scss';

export function DeleteReplyModal() {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	const handleClose = () => {
		actions$.next({
			type: ActionType.OnReplyDeleteModalCloseClick,
			requestType: RequestType.Parallel,
		});
	};

	const handleDeleteClick = () => {
		actions$.next({
			type: ActionType.OnReplyDeleteModalDeleteClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<Modal.Custom
			onClose={handleClose}
			noPadding
			className="discuss-delete-question-modal"
		>
			<div className="discuss-delete-question-modal__wrapper">
				<h4 className="discuss-delete-question-modal__title">
					Are you sure?
				</h4>
				<p className="discuss-delete-question-modal__text">
					Your reply will be permanently deleted.
				</p>
				<div className="discuss-delete-question-modal__buttons">
					<Button
						type="button"
						buttonType="secondary"
						size="m"
						onClick={handleClose}
					>
						Cancel
					</Button>
					<Button
						type="button"
						buttonType="danger"
						className="discuss-delete-question-modal__delete-btn"
						size="m"
						onClick={handleDeleteClick}
					>
						Delete
					</Button>
				</div>
			</div>
		</Modal.Custom>
	);
}
